import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid/Grid';
import Avatar from '@material-ui/core/Avatar';
import { useAlert, types } from 'react-alert';
import { PageTitle, SecondaryButton, PaperWithTitle, LinkText, PrimaryButton, NegativeButton, TransitionModal, UserInfoCard, RateWithNumber, ButtonWithIcon, ScrollArea, WriteReviewCard, ApproveDenialText, } from '../../../components';
import { useJobOfferDetail, useJobOffer, useMaster } from '../../../../model/hooks';
import { useClinicUser } from '../../../../model/hooks/clinic/ClinicUserHooks';
import { Utils } from '../../../../common/helper';
import { getLabelEmployment, getLabelFromString, getLabelFromTimestamp, getLabelRecruitment, getLabelReward, getLabelWorkingDate, } from '../../../common/helper';
import { JobOffer } from '../../../../model/firestore_model/job';
import { getLabelWorkingTime } from '../../../common/helper/FormHelper';
import * as Constants from '../../../common/constants';
export const JobOfferDetail = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { t } = useTranslation();
    const history = useHistory();
    const reactAlert = useAlert();
    const { master } = useMaster();
    const { jobClinic } = useClinicUser();
    const { id } = useParams();
    const location = useLocation();
    const { loadingReviewList, loadingAppliedList, loadingCheckInList, loadingApproval, loadReviewList, loadAppliedList, loadCheckInList, approvalJobApplied, } = useJobOfferDetail();
    const { loadJobOffer } = useJobOffer();
    const [isOpenModalUser, setIsOpenModalUser] = useState(false);
    const [isOpenModalReview, setIsOpenModalReview] = useState(false);
    const [jobDetail, setJobDetail] = useState(null);
    const [reviewRows, setReviewRows] = useState([]);
    const [appliedRows, setAppliedRows] = useState([]);
    const [checkInRows, setCheckInRows] = useState([]);
    // ユーザーモーダル用
    const [applyId, setApplyId] = useState('');
    const [workerId, setWorkerId] = useState('');
    // レビューを書くモーダル用
    const [appliedUser, setAppliedUser] = useState(null);
    // 求人内容を表示用に変換
    const jobOfferContent = useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!master)
            return null;
        return {
            title: getLabelFromString((_a = jobDetail) === null || _a === void 0 ? void 0 : _a.title),
            date: getLabelWorkingDate((_b = jobDetail) === null || _b === void 0 ? void 0 : _b.employmentId, (_c = jobDetail) === null || _c === void 0 ? void 0 : _c.startWorkingTime, (_d = jobDetail) === null || _d === void 0 ? void 0 : _d.endWorkingTime),
            time: getLabelWorkingTime((_e = jobDetail) === null || _e === void 0 ? void 0 : _e.employmentId, (_f = jobDetail) === null || _f === void 0 ? void 0 : _f.startWorkingTime, (_g = jobDetail) === null || _g === void 0 ? void 0 : _g.endWorkingTime),
            reward: getLabelReward(master.rewardTypeList, (_h = jobDetail) === null || _h === void 0 ? void 0 : _h.rewardTypeId, (_j = jobDetail) === null || _j === void 0 ? void 0 : _j.rewardAmount),
            type: getLabelEmployment(master.employmentList, (_k = jobDetail) === null || _k === void 0 ? void 0 : _k.employmentId),
            deadline: getLabelFromTimestamp((_l = jobDetail) === null || _l === void 0 ? void 0 : _l.offerDeadline, false),
            status: getLabelRecruitment(t, (_m = jobDetail) === null || _m === void 0 ? void 0 : _m.isRecruitment),
        };
    }, [jobDetail, master]);
    // 求人内容取得(URL共有等stateが存在しない時に再取得)
    const loadJobOfferData = async () => {
        if (Utils.isNull(jobClinic) || Utils.isNull(id))
            return null;
        const result = await loadJobOffer(jobClinic, id);
        return result.data[0];
    };
    // レビュー一覧取得
    const loadReviewListData = async (lastDocument) => {
        if (Utils.isNull(jobClinic) || Utils.isNull(id))
            return [];
        const result = await loadReviewList(jobClinic, id, lastDocument);
        return result.data.map((item) => {
            var _a;
            return {
                id: item.id,
                workerId: item.workerId,
                workerLastName: item.workerLastName,
                workerFirstName: item.workerFirstName,
                workerImageUrl: (_a = item.workerImage) === null || _a === void 0 ? void 0 : _a.url,
                rating: item.rating,
                text: item.text,
                detail: item,
            };
        });
    };
    // 応募ユーザー一覧取得
    const loadAppliedListData = async (lastDocument) => {
        if (Utils.isNull(jobClinic) || Utils.isNull(id))
            return [];
        const result = await loadAppliedList(jobClinic, id, lastDocument);
        return result.data.map((item) => {
            var _a, _b;
            return {
                id: item.id,
                workerId: item.workerId,
                workerLastName: item.workerLastName,
                workerFirstName: item.workerFirstName,
                workerImageUrl: (_a = item.workerImage) === null || _a === void 0 ? void 0 : _a.url,
                isApprove: (_b = item.isApprove, (_b !== null && _b !== void 0 ? _b : null)),
                detail: item,
            };
        });
    };
    // チェックイン一覧取得
    const loadCheckInListData = async (lastDocument) => {
        if (Utils.isNull(jobClinic) || Utils.isNull(id))
            return [];
        const result = await loadCheckInList(jobClinic, id, lastDocument);
        return result.data.map((item) => {
            var _a;
            return {
                workerId: item.workerId,
                workerLastName: item.workerLastName,
                workerFirstName: item.workerFirstName,
                workerImageUrl: (_a = item.workerImage) === null || _a === void 0 ? void 0 : _a.url,
                createdAt: getLabelFromTimestamp(item.createdAt, false),
                detail: item,
            };
        });
    };
    // 非同期に実行するために各一覧取得毎にuseEffectを定義
    useEffect(() => {
        if (!jobClinic)
            return;
        // stateがなければ再取得、あればstateから設定
        if (!location.state) {
            const f = async () => {
                try {
                    const result = await loadJobOfferData();
                    setJobDetail(result);
                }
                catch (e) {
                    if (e instanceof Error)
                        reactAlert.show(e.message, { type: types.ERROR });
                }
            };
            f();
        }
        else {
            setJobDetail(JobOffer.fromData(location.state.jobOffer, jobClinic.jobOffers.collectionReference.doc(id)));
            // リロード時は最新の情報を取得したいためhistoryのstateを削除
            history.replace(history.location.pathname);
        }
    }, [jobClinic]);
    useEffect(() => {
        const f = async () => {
            try {
                const _rowsReview = await loadReviewListData();
                setReviewRows(_rowsReview);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        f();
    }, [jobClinic]);
    useEffect(() => {
        const f = async () => {
            try {
                const _rowsApplied = await loadAppliedListData();
                setAppliedRows(_rowsApplied);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        f();
    }, [jobClinic]);
    useEffect(() => {
        const f = async () => {
            try {
                const _rowsCheckIn = await loadCheckInListData();
                setCheckInRows(_rowsCheckIn);
            }
            catch (e) {
                if (e instanceof Error)
                    reactAlert.show(e.message, { type: types.ERROR });
            }
        };
        f();
    }, [jobClinic]);
    const onClickMoreReviewList = async () => {
        if (reviewRows.length > 0) {
            const lastRow = reviewRows.slice(-1)[0];
            const _rows = await loadReviewListData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setReviewRows(reviewRows.concat(_rows));
            }
        }
    };
    const onClickMoreAppliedList = async () => {
        if (appliedRows.length > 0) {
            const lastRow = appliedRows.slice(-1)[0];
            const _rows = await loadAppliedListData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setAppliedRows(appliedRows.concat(_rows));
            }
        }
    };
    const onClickMoreCheckInList = async () => {
        if (checkInRows.length > 0) {
            const lastRow = checkInRows.slice(-1)[0];
            const _rows = await loadCheckInListData(lastRow.detail.snapshot);
            if (_rows.length > 0) {
                setCheckInRows(checkInRows.concat(_rows));
            }
        }
    };
    // 承認・否認押下
    const onClickApprovalDenial = async (workerId, jobOfferId, isApprove) => {
        try {
            await approvalJobApplied(workerId, jobOfferId, isApprove);
            const message = isApprove ? t('承認しました') : t('否認しました');
            reactAlert.show(message, { type: types.SUCCESS });
        }
        catch (e) {
            if (e instanceof Error)
                reactAlert.show(e.message, { type: types.ERROR });
        }
    };
    const onCloseModalUser = () => setIsOpenModalUser(false);
    const onCloseModalReview = () => setIsOpenModalReview(false);
    const onClickUserName = async (applyId, workerId) => {
        setApplyId(applyId);
        setWorkerId(workerId);
        setIsOpenModalUser(true);
    };
    const onClickWriteReview = (id) => {
        const row = appliedRows.find((obj) => obj.id === id);
        row && setAppliedUser(row);
        setIsOpenModalReview(true);
    };
    const onClickToJobOfferEdit = () => {
        var _a, _b;
        history.push(`/home/job_offer/edit_contents?id=${(_a = jobDetail) === null || _a === void 0 ? void 0 : _a.jobOfferId}`, { jobOffer: (_b = jobDetail) === null || _b === void 0 ? void 0 : _b.data() });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PageTitle, null, t('求人詳細')),
        React.createElement(SGrid, { container: true, spacing: 3 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(SJobTitle, null, (_a = jobOfferContent) === null || _a === void 0 ? void 0 : _a.title)),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(PaperWithTitle, { title: "\u6C42\u4EBA\u5185\u5BB9", titleButton: React.createElement(SecondaryButton, { disabled: !jobDetail, onClick: onClickToJobOfferEdit }, "\u6C42\u4EBA\u5185\u5BB9\u78BA\u8A8D") },
                    React.createElement(SPaperContainer, null,
                        React.createElement(SItemName, null, "\u696D\u52D9\u5185\u5BB9"),
                        React.createElement(SItemDescription, null, (_b = jobOfferContent) === null || _b === void 0 ? void 0 : _b.title),
                        React.createElement(SRow, null,
                            React.createElement("div", { style: { paddingRight: '32px' } },
                                React.createElement(SItemName, null, "\u65E5\u4ED8"),
                                React.createElement(SItemDescription, null, (_c = jobOfferContent) === null || _c === void 0 ? void 0 : _c.date)),
                            React.createElement("div", null,
                                React.createElement(SItemName, null, "\u6642\u9593"),
                                React.createElement(SItemDescription, null, (_d = jobOfferContent) === null || _d === void 0 ? void 0 : _d.time))),
                        React.createElement(SItemName, null, "\u5831\u916C"),
                        React.createElement(SItemDescription, null, (_e = jobOfferContent) === null || _e === void 0 ? void 0 : _e.reward),
                        React.createElement(SItemName, null, "\u96C7\u7528\u5F62\u614B"),
                        React.createElement(SItemDescription, null, (_f = jobOfferContent) === null || _f === void 0 ? void 0 : _f.type),
                        React.createElement(SItemName, null, "\u7DE0\u5207\u65E5\u6642"),
                        React.createElement(SItemDescription, null, (_g = jobOfferContent) === null || _g === void 0 ? void 0 : _g.deadline),
                        React.createElement(SItemName, null, "\u72B6\u6CC1"),
                        React.createElement(SItemDescription, null, (_h = jobOfferContent) === null || _h === void 0 ? void 0 : _h.status)))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(PaperWithTitle, { title: "\u5FDC\u52DF\u30E6\u30FC\u30B6\u30FC" },
                    React.createElement(SPaperContainer, null,
                        React.createElement(ScrollArea, { height: "368px" },
                            appliedRows.map((obj, idx) => {
                                return (React.createElement(SRow, { key: `${idx}${obj.workerId}` },
                                    React.createElement(SAvatar, { src: obj.workerImageUrl, alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF" }),
                                    React.createElement(LinkText, { onClick: () => onClickUserName(obj.id, obj.workerId) }, `${obj.workerLastName} ${obj.workerFirstName}`),
                                    React.createElement("div", { style: { marginLeft: 'auto' } },
                                        obj.isApprove === null ? (React.createElement(SApproveButtonArea, null,
                                            React.createElement(PrimaryButton, { size: "small", loading: loadingApproval, onClick: () => onClickApprovalDenial(obj.workerId, id, true) }, t('承認')),
                                            React.createElement(SSpacer, { ml: "8px" },
                                                React.createElement(NegativeButton, { size: "small", loading: loadingApproval, onClick: () => onClickApprovalDenial(obj.workerId, id, false) }, t('否認'))))) : (React.createElement(ApproveDenialText, { isApprove: obj.isApprove })),
                                        React.createElement(SReviewLinkWrapper, null,
                                            React.createElement(LinkText, { onClick: () => onClickWriteReview(obj.id) }, t('レビューを書く'))))));
                            }),
                            React.createElement("div", { style: { textAlign: 'center' } },
                                React.createElement(ButtonWithIcon, { text: "\u3082\u3063\u3068\u898B\u308B", iconName: "expand_more", iconPosition: "end", loading: loadingAppliedList, onClick: onClickMoreAppliedList })))))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(PaperWithTitle, { title: "\u30EC\u30D3\u30E5\u30FC" },
                    React.createElement(SPaperContainer, null,
                        React.createElement(ScrollArea, { height: "300px" },
                            reviewRows.map((obj, idx) => {
                                return (React.createElement("div", { key: `${idx}${obj.workerId}` },
                                    React.createElement(SRow, null,
                                        React.createElement(SAvatar, { src: obj.workerImageUrl, alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF" }),
                                        React.createElement(SUserName, null, `${obj.workerLastName} ${obj.workerFirstName}`),
                                        React.createElement(SSpacer, { ml: "16px" },
                                            React.createElement(RateWithNumber, { value: obj.rating, size: "small" }))),
                                    React.createElement(SReviewContent, null, obj.text)));
                            }),
                            React.createElement("div", { style: { textAlign: 'center' } },
                                React.createElement(ButtonWithIcon, { text: "\u3082\u3063\u3068\u898B\u308B", iconName: "expand_more", iconPosition: "end", loading: loadingReviewList, onClick: onClickMoreReviewList })))))),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                React.createElement(PaperWithTitle, { title: "\u30C1\u30A7\u30C3\u30AF\u30A4\u30F3" },
                    React.createElement(SPaperContainer, null,
                        React.createElement(ScrollArea, { height: "300px" },
                            checkInRows.map((obj, idx) => {
                                return (React.createElement(SRow, { key: `${idx}${obj.workerId}` },
                                    React.createElement(SAvatar, { src: obj.workerImageUrl, alt: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u753B\u50CF" }),
                                    React.createElement(SUserName, null, `${obj.workerLastName} ${obj.workerFirstName}`),
                                    React.createElement("div", { style: { marginLeft: 'auto' } },
                                        React.createElement(SCheckinTime, null, obj.createdAt))));
                            }),
                            React.createElement("div", { style: { textAlign: 'center' } },
                                React.createElement(ButtonWithIcon, { text: "\u3082\u3063\u3068\u898B\u308B", iconName: "expand_more", iconPosition: "end", loading: loadingCheckInList, onClick: onClickMoreCheckInList }))))))),
        React.createElement(TransitionModal, { isOpen: isOpenModalUser, onClose: onCloseModalUser }, jobDetail !== null && (React.createElement(UserInfoCard, { userId: workerId, applyId: applyId, jobOfferId: id, jobOffer: jobDetail }))),
        React.createElement(TransitionModal, { isOpen: isOpenModalReview, size: "small", onClose: onCloseModalReview },
            React.createElement(WriteReviewCard, { appliedUser: appliedUser, setOpen: setIsOpenModalReview }))));
};
const SGrid = styled(Grid) `
  padding-bottom: 32px;
  font-size: 15px;
`;
const SPaperContainer = styled.div `
  padding: 12px;
`;
const SJobTitle = styled.p `
  font-size: 26px;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 0;
`;
const SItemName = styled.p `
  margin-bottom: 4px;
`;
const SItemDescription = styled.p `
  margin-bottom: 12px;
  font-weight: bold;
`;
const SAvatar = styled(Avatar) `
  &&& {
    width: 40px;
    height: 40px;
    margin-right: 12px;
  }
`;
const SRow = styled.div `
  display: flex;
  align-items: center;
  margin-top: 16px;
`;
const SApproveButtonArea = styled.div `
  display: flex;
  align-items: center;
`;
const SSpacer = styled.span `
  margin-left: ${({ ml }) => ml};
`;
const SReviewLinkWrapper = styled.div `
  text-align: right;
  margin-top: 6px;
`;
const SReviewContent = styled.p `
  font-size: 13px;
  margin-top: 6px;
  margin-bottom: 0;
`;
const SCheckinTime = styled.p `
  font-size: 13px;
  margin: 0;
`;
const SUserName = styled.p `
  color: ${Constants.COLOR.ORANGE700};
  font-weight: bold;
  margin: 0;
`;
